/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeconferencescardtitle3Inputs */



/**
* | output |
* | --- |
* | "Conferences" |
*
* @param {Homeconferencescardtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeconferencescardtitle3 = /** @type {((inputs?: Homeconferencescardtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeconferencescardtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Conferences")
	return /** @type {LocalizedString} */ ("Konferenzen")
});
export { homeconferencescardtitle3 as "homeConferencesCardTitle" }